export default {
    wbl_category_column: {
        column_name: "열 이름",
        column_type: "열 유형",
        order_value: "주문 가치"
      }
}